import { render, staticRenderFns } from "./AddBaseProductPage.vue?vue&type=template&id=6b09e152&scoped=true"
import script from "./AddBaseProductPage.vue?vue&type=script&lang=js"
export * from "./AddBaseProductPage.vue?vue&type=script&lang=js"
import style0 from "./AddBaseProductPage.vue?vue&type=style&index=0&id=6b09e152&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b09e152",
  null
  
)

export default component.exports